import { render, staticRenderFns } from "./PrkCommentModalButton.vue?vue&type=template&id=15e0037d&scoped=true&"
import script from "./PrkCommentModalButton.vue?vue&type=script&lang=js&"
export * from "./PrkCommentModalButton.vue?vue&type=script&lang=js&"
import style0 from "./PrkCommentModalButton.vue?vue&type=style&index=0&id=15e0037d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e0037d",
  null
  
)

export default component.exports